import { useState } from 'react';

const useAddToCart = () => {
    const [data, setData] = useState([]);

    const addToCart = async (item) => {
        // console.log('item in window call', item);
        // @ts-ignore
        return await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: item
        })
            .then((response) => {
                console.log('response', response);
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    return { addToCart, setData, data };
};
export default useAddToCart;
